export const siteConfig = {
  name: "Forum Technical Solutions",
  shortName: "Forum Tech",
  tagline: "Expert Device Repair in Long Island City, NY. Serving All of New York State.",
  domain: "https://forumtechnicalsolution.com",
  address: {
    street: "38-33 29th St",
    city: "Long Island City",
    state: "NY",
    zip: "11101",
    country: "United States",
    full: "38-33 29th St, Long Island City, NY 11101, United States",
    display: "38-33 29th St\nLong Island City, NY 11101",
  },
  coordinates: {
    lat: 40.7536365,
    lng: -73.934121,
  },
  phone: {
    display: "+1 718-606-8866",
    tel: "tel:+17186068866",
    whatsapp: "https://wa.me/17186068866",
    raw: "+17186068866",
  },
  email: {
    support: "support@forumtechnicalsolution.com",
    shop: "accesscafe4015@gmail.com",
  },
  hours: [
    { day: "Monday", open: "11:30", close: "19:30", dayIndex: 1 },
    { day: "Tuesday", open: "11:30", close: "19:30", dayIndex: 2 },
    { day: "Wednesday", open: "11:30", close: "19:30", dayIndex: 3 },
    { day: "Thursday", open: "11:30", close: "19:30", dayIndex: 4 },
    { day: "Friday", open: "11:30", close: "19:30", dayIndex: 5 },
    { day: "Saturday", open: "11:30", close: "19:30", dayIndex: 6 },
    { day: "Sunday", open: "13:00", close: "20:00", dayIndex: 0 },
  ],
  hoursDisplay: [
    { label: "Monday – Saturday", time: "11:30 AM – 7:30 PM" },
    { label: "Sunday", time: "1:00 PM – 8:00 PM" },
  ],
  googleProfile: {
    url: "",
    reviewCountLabel: "500+",
    rating: null as number | null,
  },
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=38-33+29th+St+Long+Island+City+NY+11101",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9!2d-73.934121!3d40.7536365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ1JzEzLjEiTiA3M8KwNTYnMDIuOCJX!5e0!3m2!1sen!2sus!4v1",
  social: {},
} as const;

export type SiteConfig = typeof siteConfig;

export function getOpenStatus(): {
  isOpen: boolean;
  statusText: string;
  nextChange: string;
} {
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
  );
  const dayIndex = now.getDay();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const todayHours = siteConfig.hours.find((h) => h.dayIndex === dayIndex);

  if (!todayHours) {
    return { isOpen: false, statusText: "Closed today", nextChange: "" };
  }

  const [openH, openM] = todayHours.open.split(":").map(Number);
  const [closeH, closeM] = todayHours.close.split(":").map(Number);
  const openMinutes = openH * 60 + openM;
  const closeMinutes = closeH * 60 + closeM;

  const formatTime = (h: number, m: number) => {
    const period = h >= 12 ? "PM" : "AM";
    const displayH = h > 12 ? h - 12 : h === 0 ? 12 : h;
    return `${displayH}:${m.toString().padStart(2, "0")} ${period}`;
  };

  if (currentMinutes >= openMinutes && currentMinutes < closeMinutes) {
    return {
      isOpen: true,
      statusText: `Open now until ${formatTime(closeH, closeM)}`,
      nextChange: formatTime(closeH, closeM),
    };
  } else {
    return {
      isOpen: false,
      statusText: `Closed. Opens at ${formatTime(openH, openM)}`,
      nextChange: formatTime(openH, openM),
    };
  }
}